import styled from 'styled-components'

export const AlertWrapper = styled.div`
  margin-bottom: -24px;
`
